import { ContainerModule } from '@evertel/di'
import { IntegrationController, IntegrationEventLogSearchController } from './controllers'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(IntegrationController).toSelf()
        m.bind(IntegrationEventLogSearchController).toSelf()
    })
]

export { DI_MODULES }
